module.exports = __webpack_public_path__ + "static/media/xmas_v2.09e1e7b9.jpg";